import { useMemo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import { markSvg } from '../../brand/mark';

/** The NeuralRepo mark (D-83) as an inline icon, without its tile; follows the theme. */
export function NeuralIcon({ size = 16, className }: { size?: number; className?: string }) {
  const { resolvedTheme } = useTheme();
  const svg = useMemo(
    () => markSvg({ size, ground: resolvedTheme === 'light' ? 'paper' : 'charcoal', tile: false }),
    [size, resolvedTheme],
  );
  return (
    <span
      className={className}
      style={{ display: 'inline-flex', width: size, height: size, lineHeight: 0 }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
